import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-editnews',
  templateUrl: './admin-editnews.component.html',
  styleUrls: ['./admin-editnews.component.sass']
})
export class AdminEditnewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
